import React from "react";
import { Route } from "react-router-dom";
import Loadable from "react-loadable";
import loading from "./Loading";

const RouteLoader = ({ loader, ...props }, { store }) => {
  const opts = {
    loader,
    loading,
    delay: 200,
    timeout: 10000
  };
  return <Route component={Loadable(opts)} {...props} />;
};

export default RouteLoader;



// WEBPACK FOOTER //
// ./src/services/route-loader/RouteLoader.js